<template>
  <div v-if="currentStep === stepType.DELIVERY">
    <template v-if="isProductEVoucher">
      <section>
        <delivery-download-access-form :delivery_id="0" class="mb-5" />
      </section>
    </template>
    <template v-else-if="isProductVirtualNDE">
      <section>
        <delivery-download-access-form :delivery_id="0" isCard class="mb-5" />
      </section>
    </template>
    <template v-else-if="!isProductVirtualCard">
      <delivery-download-access-form v-if="isProductNDE" :delivery_id="0" isCard class="mb-5" />

      <template v-if="showDeliveryPointsForm">
        <delivery-points-input-mode-form v-if="isProductNDE && !hasIndividualPersonalization" />
        <delivery-points-count-select-form v-else-if="isProductNDE && hasIndividualPersonalization" />
        <delivery-points-number-form-section v-else-if="!isProductNDE" />
      </template>

      <template v-if="!isProductNDE || isManualInputMode">
        <section v-if="deliveryPointsCount > 1" class="multipleDeliveryPoints deliveryPointForm">
          <ProductFormWrapper v-for="i in deliveryPointsCount" :key="i" :delivery_id="i - 1" />
        </section>
        <section v-else>
          <div class="deliveryPointForm mb-5">
            <div class="formWrapper">
              <div class="formWrapper__header">
                <Icon icon="delivery" class="formWrapper__header__icon" />
                <h3>Punkt dostawy</h3>
              </div>
              <div class="formWrapper__inner">
                <delivery-addres-form :delivery_id="0" />
                <upload-file :delivery_id="0"></upload-file>
              </div>
            </div>
          </div>
        </section>
      </template>
    </template>
    <delivery-additional-info></delivery-additional-info>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Icon from '@/components/Icon.vue';
import UploadFile from '@/components/Upload/UploadFile.vue';
import ProductFormWrapper from '@/components/Product/ProductFormWrapper.vue';
import DeliveryAddresForm from '@/components/DeliveryAddressForm/DeliveryAddressForm.vue';
import DeliveryDownloadAccessForm from '@/components/DeliveryAddressForm/DeliveryDownloadAccessForm.vue';
import DeliveryPointsInputModeForm from '@/components/DeliveryPoints/DeliveryPointsInputModeForm.vue';
import DeliveryPointsCountSelectForm from '@/components/DeliveryPoints/DeliveryPointsCountSelectForm.vue';
import DeliveryPointsNumberFormSection from '@/components/DeliveryPoints/DeliveryPointsNumberFormSection.vue';
import DeliveryAdditionalInfo from '@/components/AdditionalInfoForm/DeliveryAdditionalInfo.vue';

export default {
  name: 'step4',
  components: {
    UploadFile,
    DeliveryAddresForm,
    ProductFormWrapper,
    DeliveryDownloadAccessForm,
    DeliveryPointsInputModeForm,
    DeliveryPointsCountSelectForm,
    DeliveryPointsNumberFormSection,
    DeliveryAdditionalInfo,
    Icon,
  },
  computed: {
    ...mapState({
      stepType: state => state.steps.stepType,
      hasIndividualPersonalization: state => state.confection.hasIndividualPersonalization,
    }),
    isManualInputMode() {
      return this.$store.state.delivery.inputMode === 'manual';
    },
    deliveryPointsCount() {
      return this.$store.state.cart.deliveries_no;
    },
    currentStep() {
      return this.$store.state.steps.currentStep;
    },
    cartItemsCount() {
      return this.$store.getters['delivery/getItemsCount'] > 0;
    },
    getProductType() {
      return this.$store.getters.getProductType;
    },
    isProductEVoucher() {
      return this.$store.getters.isProductEVoucher;
    },
    isProductVirtualNDE() {
      return this.$store.getters.isProductVirtualNDE;
    },
    isProductVirtualCard() {
      return this.$store.getters.isProductVirtualCard;
    },
    isProductNDE() {
      return this.$store.getters.isProductNDE;
    },
    showDeliveryPointsForm() {
      return !!this.$store.getters.getDeliveryAddressProduct;
    },
  },
  created() {
    this.$store.dispatch('delivery/bindBackendDeliveries');
    if (!this.$store.state.cart.userIsGuest) {
      this.$store.dispatch('delivery/bindBackendDeliveries');
    }
  },
};
</script>

<style scoped></style>
